import React, { Component } from 'react';
import { HashRouter, BrowserRouter, Route, Switch, Link, NavLink } from "react-router-dom";

import PageView from './components/PageView';
import PageMenu from './components/PageMenu';
import GoogleAnalytics from './components/GoogleAnalytics';
import SiteFooter from './components/SiteFooter';
import SearchOverview from './components/SearchOverview';
import OrnefnaskraView from './components/OrnefnaskraView';
import OrnefniView from './components/OrnefniView';
import EinstaklingurView from './components/EinstaklingurView';
import BaerView from './components/BaerView';
import SavedItemsView from './components/SavedItemsView';
import SearchBox from './components/SearchBox';
import SyslurListView from './components/SyslurListView';
import HrepparListView from './components/HrepparListView';
import SveitarFelogListView from './components/SveitarFelogListView';
import BrowseMapView from './components/BrowseMapView';
import GreinView from './components/GreinView';
import GreinarListView from './components/GreinarListView';
import NofnislendingaView from './components/NofnislendingaView';

import logo from './img/logo.png';
import config from './config';
import localLibrary from './utils/localLibrary';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

class App extends Component {
	constructor(props) {
		super(props);

		this.menuButtonClickHandler = this.menuButtonClickHandler.bind(this);
		this.languageChangedHandler = this.languageChangedHandler.bind(this);

		localLibrary.registerSignal(function() {
			this.forceUpdate();
		}.bind(this));

		this.state = {
			searchParams: {}
		};
	}

	componentDidMount() {
		this.refs.router.history.listen((event) => {
			this.setState({
				menuOpen: false
			});

			if (event.pathname.startsWith('/ornefnaskra/') || event.pathname.startsWith('/kort')) {
				document.body.classList.add('full-screen');
			}
			else {
				document.body.classList.remove('full-screen');
			}
		});

		if (this.refs.router.history.location.pathname.startsWith('/ornefnaskra/') || this.refs.router.history.location.pathname.startsWith('/kort')) {
			document.body.classList.add('full-screen');
		}

		document.addEventListener('mousedown', function(event) {
			if (!this.state.menuOpen) {
				return;
			}

			if (this.refs.menuButton.contains(event.target)) {
				event.stopPropagation();

				return;
			}

			if (this.refs.menuContent && !this.refs.menuContent.contains(event.target)) {
				this.setState({
					menuOpen: false
				})
			}
		}.bind(this));
	}

	languageChangedHandler() {
		this.forceUpdate();
	}

	menuButtonClickHandler(event) {
		event.stopPropagation();
		if (!this.state.menuOpen) {
			this.refs.menuContent.scrollTop = 0;
		}

		this.setState({
			menuOpen: !this.state.menuOpen
		});
	}

	render() {
		let isFrontPage = this.refs.router && this.refs.router.history.location.pathname == '/';

		return (
			<BrowserRouter ref="router">
				<React.Fragment>
					<div className="header hidden-print">

						<div className="container larger">
							<h1 className="h2 font-lido">
								<img src={logo} style={{width: 60}} className="mr-4" />
								<span>{config.siteTitle} </span>
							</h1>

							<button ref="menuButton" className="app-menu-button btn-menu hidden-mobile-up" onClick={this.menuButtonClickHandler}>
								<div className="hamburger-icon">
									<div className="icon-middle"></div>
									<div className="icon-before-after"></div>
								</div>
							</button>

							<PageMenu className="hidden-mobile" />
						</div>

					</div>

					<SearchBox />

					<div className={'container main-container larger'+(this.state.searchFormSticky ? ' searchform-sticky' : '')}>
						<Switch>

							<Route exact path="/" render={(routeProps) => (
								<React.Fragment>
									<PageView />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/minarskrar" render={(routeProps) => (
								<React.Fragment>
									<SavedItemsView />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/sveitarfelog/:id*" render={(routeProps) => (
								<React.Fragment>
									<SveitarFelogListView />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/syslur/:id*" render={(routeProps) => (
								<React.Fragment>
									<SyslurListView />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/hreppur/:id" render={(routeProps) => (
								<React.Fragment>
									<HrepparListView />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/baer/:id" render={(routeProps) => (
								<React.Fragment>
									<BaerView {...routeProps} />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/einstaklingur/:id" render={(routeProps) => (
								<React.Fragment>
									<EinstaklingurView {...routeProps} />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/ornefnaskra/:id" render={(routeProps) => (
								<Redirect to={routeProps.location.pathname+'/pdf'} />
							)} />

							<Route exact path="/ornefnaskra/:id/:tab" render={(routeProps) => (
								<React.Fragment>
									<OrnefnaskraView {...routeProps} />
								</React.Fragment>
							)} />

							<Route exact path="/ornefni/:id" render={(routeProps) => (
								<React.Fragment>
									<OrnefniView {...routeProps} />
								</React.Fragment>
							)} />

							<Route exact path="/kort/" render={(routeProps) => (
								<React.Fragment>
									<BrowseMapView />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/greinar/:id*" render={(routeProps) => (
								<React.Fragment>
									<GreinarListView {...routeProps} />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/grein/:id" render={(routeProps) => (
								<React.Fragment>
									<GreinView {...routeProps} />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route exact path="/nofnislendinga/:id" render={(routeProps) => (
								<React.Fragment>
									<NofnislendingaView {...routeProps} />

									<SiteFooter />
								</React.Fragment>
							)} />

							<Route path="/leit/*">
								<Route exact path="(/leit/)?:view*(/)?:searchString*(/sida/)?:page*(/sysla/)?:sysla*(/hreppur/)?:hreppur*(/sveitarfelag/)?:sveitarfelag*(/tegund/)?:tegund*" render={(routeProps) => (
									<React.Fragment>
										<SearchOverview {...routeProps} />

										<SiteFooter />
									</React.Fragment>
								)} />
							</Route>

							<Route exact path="/*" render={(routeProps) => (
								<React.Fragment>
									<PageView />

									<SiteFooter />
								</React.Fragment>
							)} />

						</Switch>

					</div>

					<div className={'app-menu'+(this.state.menuOpen ? ' open' : '')} ref="menuContent">
						<div className="container">

							<button ref="menuButton" className="btn btn-link float-right" onClick={
								function() {
									this.setState({
										menuOpen: false
									});
								}.bind(this)}>
								<div className="hamburger-icon black open">
									<div className="icon-middle" />
									<div className="icon-before-after" />
								</div>
							</button>

							<h5 className="mb-4 pt-2">{config.siteTitle}</h5>

							<div className="menu-links">

								<PageMenu />

							</div>

						</div>
					</div>

					<GoogleAnalytics />

				</React.Fragment>
			</BrowserRouter>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js